import ExerciseSupport from '../../../student/components/exercises/ExerciseSupport';
import { Box, Stack, Typography } from '@mui/material';
import { ImageExercise, shows } from '../../../student/mockLessonContent';
import { BLUE, cardSx, INTER, NAVY, POPPINS, SLATE } from '../../../student/studentStyles';
import AudioPlayButton from '../../../student/components/AudioPlayButton';
import ImageZoom from '../../../student/components/ImageZoom';
import ExerciseLabel from '../../../student/components/exercises/ExerciseLabel';
import { useExerciseLayout } from './exerciseLayout';

// "Dialog w/ Image" — a picture and a teacher line to set the scene, or a plain
// "Dialog Only" line when there is no picture. Nothing to answer, so the player
// lets the student continue straight away. The picture opens full size on tap.
export default function ImageExerciseCard({ exercise }: { exercise: ImageExercise }) {
    const desktop = useExerciseLayout() === 'desktop';

    return (
        <Box>
            <ExerciseLabel>{exercise.emoji ? 'LOOK' : 'FROM YOUR TEACHER'}</ExerciseLabel>
            <Box sx={{ ...cardSx, overflow: 'hidden' }}>
                {exercise.emoji && (
                    <ImageZoom emoji={exercise.emoji} alt={exercise.caption} height={desktop ? 220 : 190} fontSize={88} />
                )}
                <Box sx={{ p: desktop ? 3 : 2.5 }}>
                    <Typography sx={{ fontFamily: INTER, fontSize: 15, color: SLATE, lineHeight: 1.5 }}>
                        {exercise.caption}
                    </Typography>
                    {exercise.chinese && (
                        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mt: 2 }}>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography sx={{ fontFamily: POPPINS, fontWeight: 600, fontSize: 20, color: NAVY, lineHeight: 1.4 }}>
                                    {exercise.chinese.hanzi}
                                </Typography>
                                {shows(exercise, 'pinyin') && (
                                    <Typography sx={{ fontFamily: INTER, fontSize: 13, color: BLUE, mt: 0.25 }}>
                                        {exercise.chinese.pinyin}
                                    </Typography>
                                )}
                            </Box>
                            <AudioPlayButton ariaLabel="Play teacher audio" size={40} />
                        </Stack>
                    )}
                    <ExerciseSupport exercise={exercise} />
                </Box>
            </Box>
        </Box>
    );
}
